import { render } from "./SelectedGenesModal.vue?vue&type=template&id=ae771862&scoped=true"
import script from "./SelectedGenesModal.vue?vue&type=script&lang=js"
export * from "./SelectedGenesModal.vue?vue&type=script&lang=js"

import "./SelectedGenesModal.vue?vue&type=style&index=0&id=ae771862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae771862"]])

export default __exports__